import React from 'react'
import '../styles/title.css'

const Title = () => {
  return (
    <>
        <div className='title__name'>
            <h1>Alan Martinez</h1>
        </div>
        <div className='title__dev'>
            <h2>Software Engineer</h2>
        </div>
    </>
  )
}

export default Title